"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GvfService = void 0;
const VehicleCommissionDataHelper_1 = require("./VehicleCommissionDataHelper");
const GvfNetworkError_1 = require("./errors/GvfNetworkError");
const SpecificationFilter_1 = require("./SpecificationFilter");
const ServiceConfigHelper_1 = require("../serviceConfig/ServiceConfigHelper");
class GvfService {
    constructor(gvfClient, serviceConfigProvider) {
        this.gvfClient = gvfClient;
        this.serviceConfigProvider = serviceConfigProvider;
        const gvfCustomServiceConfig = serviceConfigProvider.configs['myvw_group-vehicle-file'].customConfig;
        const validBids = gvfCustomServiceConfig.validBids;
        this.vehicleCommissionDataHelper = new VehicleCommissionDataHelper_1.VehicleCommissionDataHelper(validBids);
        this.specificationFilter = new SpecificationFilter_1.SpecificationFilter(gvfCustomServiceConfig.prNumberOrigins);
    }
    async getGvfEnrichedVehicle(vehicle, modelNameFallback) {
        if (vehicle.vin) {
            vehicle = await this.getGvfEnrichedVinVehicle(vehicle);
        }
        else if (vehicle.commissionNumber) {
            const commissionVehicleCombinations = this.vehicleCommissionDataHelper.getAllCommissionVehicleCombinations(vehicle);
            vehicle = await this.getGvfEnrichedCommissionDataVehicle(commissionVehicleCombinations);
        }
        if ((0, ServiceConfigHelper_1.getCustomConfig)(this.serviceConfigProvider.configs['myvw_group-vehicle-file']).useFallbackForModelName) {
            return Object.assign(Object.assign({}, vehicle), { modelName: modelNameFallback });
        }
        return vehicle;
    }
    async getGvfVehicleData(vehicle, modelNameFallback) {
        if (vehicle.vin) {
            const basicGvfData = await this.gvfClient.getGvfData(vehicle.vin);
            vehicle = Object.assign(Object.assign({}, vehicle), basicGvfData);
        }
        else if (vehicle.commissionNumber) {
            const commissionVehicleCombinations = this.vehicleCommissionDataHelper.getAllCommissionVehicleCombinations(vehicle);
            const basicGvfData = await this.getVehicleWithGvfDataForPossibleCombinations(commissionVehicleCombinations);
            vehicle = Object.assign(Object.assign({}, vehicle), basicGvfData);
        }
        if ((0, ServiceConfigHelper_1.getCustomConfig)(this.serviceConfigProvider.configs['myvw_group-vehicle-file']).useFallbackForModelName) {
            return Object.assign(Object.assign({}, vehicle), { modelName: modelNameFallback });
        }
        return vehicle;
    }
    async getGvfEnrichedVinVehicle(vehicle) {
        const gvfDataResponse = await this.gvfClient.getGvfData(vehicle.vin);
        const gvfDetailsResponse = await this.gvfClient.getGvfDetails(vehicle.vin);
        let specifications = this.specificationFilter.filter(gvfDetailsResponse);
        return Object.assign(Object.assign(Object.assign(Object.assign({}, vehicle), gvfDataResponse), gvfDetailsResponse), { specifications });
    }
    async getGvfPrNumberService(vin) {
        const getGvfPrNumberResponse = await this.gvfClient.getGvfPrNumber(vin);
        return getGvfPrNumberResponse;
    }
    async getGvfEnrichedCommissionDataVehicle(vehicles) {
        const gvfDataResponse = await this.getVehicleWithGvfDataForPossibleCombinations(vehicles);
        const gvfDetailsResponse = await this.gvfClient.getGvfDetails(gvfDataResponse.bid + gvfDataResponse.commissionNumberYear + gvfDataResponse.commissionNumber);
        let specifications = this.specificationFilter.filter(gvfDetailsResponse);
        return Object.assign(Object.assign(Object.assign({}, gvfDataResponse), gvfDetailsResponse), { specifications });
    }
    async getVehicleWithGvfDataForPossibleCombinations(vehicles) {
        let lastException = new GvfNetworkError_1.GvfNetworkError();
        let gvfResponsesWithBids = await Promise.all(vehicles.map(async (vehicle) => {
            try {
                const response = await this.gvfClient.getGvfData(vehicle.bid + vehicle.commissionNumberYear + vehicle.commissionNumber);
                if (response) {
                    return Object.assign(Object.assign({}, vehicle), response);
                }
            }
            catch (e) {
                lastException = e;
            }
            return undefined;
        }));
        const result = gvfResponsesWithBids.find((response) => response !== undefined);
        if (result) {
            return result;
        }
        else {
            throw lastException;
        }
    }
}
exports.GvfService = GvfService;
//# sourceMappingURL=GvfService.js.map